import { axiosWithConfig } from '@assembly/config/axios'
import { AssemblyLineQuery, PaginatedResponse, AssemblyLine } from '@assembly/pages/AssemblyLines/types'

export interface AssemblyLineSubscriptionConfig {
  id?: string
  name: string
  description?: string
  /** Omit or ASSEMBLY_AGENT_SUBSCRIPTION for agent plans; FOUNDRY_APP for Foundry self-serve. */
  targetSku?: 'FOUNDRY_APP' | 'ASSEMBLY_AGENT_SUBSCRIPTION'
}

export interface SubscriptionConfigSearchResponse {
  configs: AssemblyLineSubscriptionConfig[]
  totalCount: number
  page: number
  pageSize: number
}

export const searchSubscriptionConfigs = async (
  search: string,
  page = 0,
  pageSize = 20
): Promise<SubscriptionConfigSearchResponse> => {
  const params = new URLSearchParams()
  if (search?.trim()) params.append('search', search.trim())
  params.append('page', String(page))
  params.append('pageSize', String(pageSize))
  const { data } = await axiosWithConfig.post<SubscriptionConfigSearchResponse>(
    '/admin/assembly_line/subscription-configs/search',
    params,
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  )
  return data
}

export const getSubscriptionConfig = async (
  id: string
): Promise<AssemblyLineSubscriptionConfig | null> => {
  try {
    const { data } = await axiosWithConfig.get<AssemblyLineSubscriptionConfig>(
      `/admin/assembly_line/subscription-configs/${id}`
    )
    return data
  } catch {
    return null
  }
}

export const createAssemblyLine = (payload: any) => {
  return axiosWithConfig.post(`/admin/assembly_line`, payload)
}

export const updateAssemblyLine = (payload: any) => {
  return axiosWithConfig.put(`/admin/assembly_line`, payload)
}

export const deleteAssemblyLine = (id: string) => {
  return axiosWithConfig.delete(`/admin/assembly/${id}`)
}

export const getAssemblyLine = (id: string) => {
  return axiosWithConfig.get(`/admin/assembly_line/${id}`)
}

export const getAssemblyLines = (payload: AssemblyLineQuery): Promise<{ data: PaginatedResponse<AssemblyLine> }> => {
  return axiosWithConfig.post(`/admin/assembly_line/search`, payload)
}

export const estimateStartDate = (assemblyId: string) => {
  return axiosWithConfig.post(`/admin/assembly_line/${assemblyId}/proposal/start_date`)
}